import { createApp } from "vue";
import profileform from './components/profileform.vue';

const app = createApp(profileform);

app.mount('#profilingForm');

/*
import Vue from 'vue';
import profileform from './components/profileform.vue';

new Vue({
  el: '',
  components: { 'profileform': profileform },
  data: { },
  template: '<profileform></profileform>'
});
/**/
